// Chakra imports
import {Avatar, Button, Flex, Text, useColorModeValue,} from "@chakra-ui/react";
// Assets
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React from "react";

const RosterTable = ({title, rosterList}) => {
    // Chakra color mode
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Card p='16px'>
            <CardHeader p='12px 5px' mb='12px'>
                <Text fontSize='lg' color={textColor} fontWeight='bold'>
                    {title}
                </Text>
            </CardHeader>
            <CardBody px='5px'>
                <Flex direction='column' w='100%'>
                    {rosterList && rosterList.map((roster) => {
                        return (
                            <Flex justifyContent='space-between' mb='21px'>
                                <Flex align='center'>
                                    <Avatar
                                        src={roster?.image}
                                        w='50px'
                                        h='50px'
                                        borderRadius='15px'
                                        me='10px'
                                    />
                                    <Flex direction='column'>
                                        <Text fontSize='sm' color={textColor} fontWeight='bold'>
                                            {roster?.name} {" "}
                                        </Text>
                                        <Text fontSize='xs' color='gray.500' fontWeight='400'>
                                            {roster?.startDate} | {roster?.endDate}
                                        </Text>
                                    </Flex>
                                </Flex>
                                <Button p='0px' bg='transparent' variant='no-hover'>
                                    <Text
                                        fontSize='sm'
                                        fontWeight='600'
                                        color='teal.300'
                                        alignSelf='center'>
                                        VIEW
                                    </Text>
                                </Button>
                            </Flex>
                        )
                    })}
                </Flex>
            </CardBody>
        </Card>
    );
};

export default RosterTable;
